import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { FaqContent, FaqHeader, StyledFaqsContainer, StyledFaqsItem, StyledFaqsTitle, FaqsSection } from "./styles";

import Dropdown from "components/Dropdown";
import getFeature from "utils/getFeature";

const FaqsContainer: FunctionComponent = () => {
  const { t } = useTranslation();

  type FAQItem = {
    content: string;
    header: string;
    id: string;
  };

  const faqsData = [
    {
      id: "devices",
      header: t("What devices that I can use my subscriptions on?"),
      content: t("All subscriptions can be used on more than one device."),
    },
    {
      id: "cancel",
      header: t("How do I cancel a paid subscription?"),
      content: t(
        "If you pay for the subscription by adding the charge to your phone bill (Charge to Bill), you can cancel it at any time.",
      ),
    },
    {
      id: "transfer",
      header: t("Can I transfer my existing subscription to my Vodafone monthly plan?"),
      content: t(
        "If you already have a subscription with one of our partners, you’ll need to cancel that subscription before you can choose this subscription as part of your monthly plan. After the last day of the current billing period, you’ll be able to activate your inclusive subscription.",
      ),
    },
    {
      id: "activation",
      header: t(
        "How can I activate the services available on Vodafone Subscription+ if I already have an existing account?",
      ),
      content: t(
        "Depending on the service you choose to activate with Vodafone, you may or may not be able to transfer your current subscription. Before starting the activation of a service, please read the included description carefully. It will tell you whether you can transfer your current subscription or whether you must cancel it before activating your subscription with Vodafone.",
      ),
    },
  ];

  const finalFAQ: FAQItem[] = getFeature("Show Custom FAQ")?.options?.myCustumFQAs
    ? (getFeature("Show Custom FAQ")?.options.myCustumFQAs as FAQItem[])
    : faqsData;

  return (
    <StyledFaqsContainer>
      <FaqsSection>
        <StyledFaqsTitle data-testid={"FAQS-title"}>{t("FAQs")}</StyledFaqsTitle>
        {finalFAQ.map(({ content, header, id }, index) => (
          <StyledFaqsItem key={index}>
            <Dropdown
              arrowColor="#111111"
              content={
                <FaqContent data-testid={`FAQ-item-${id}`}>
                  <div
                    data-testid={`FAQ-item-${id}-content`}
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />
                </FaqContent>
              }
              header={
                <FaqHeader data-testid={`FAQ-item-${id}-header`} aria-label={header}>
                  {header}
                </FaqHeader>
              }
              key={index}
              panelTitle={header}
            />
          </StyledFaqsItem>
        ))}
      </FaqsSection>
    </StyledFaqsContainer>
  );
};

export default React.memo(FaqsContainer);
